import type { FunctionComponent } from 'react';
import type { TypeOrderLineProps } from './types';

/**
 * OrderLine
 */
export const OrderLine: FunctionComponent<TypeOrderLineProps> = ({
  className = '',
  children,
}: TypeOrderLineProps) => (
  <div
    className={`grid grid-cols-3 gap-7 bg-bg-secondary p-4 outline outline-1 outline-primary-100 md:grid-cols-5 md:gap-16 md:p-6 *:md:self-start [&>*:last-child]:col-span-2 [&>*:last-child]:items-end [&>*:last-child]:justify-end [&>*:last-child]:self-end [&>*:last-child]:md:col-span-2 [&>*:last-child]:md:items-start [&>*:last-child]:md:justify-end [&>*:nth-child(2n):not(:last-child)]:md:col-span-1 [&>*:nth-child(2n):not(:last-child)]:md:justify-start [&>*:nth-child(2n)]:col-span-2 [&>*:nth-child(2n)]:items-end [&>*:nth-child(2n)]:justify-end [&>*:nth-child(2n)]:md:items-start ${className}`}
  >
    {children}
  </div>
);
